module.exports = __webpack_public_path__ + "static/media/pet-avatar.ed2e332e.svg";